<div class="row w-100 p-0">
	<div class="col-sm m-0 p-2"
		[ngClass]="data ? 'col-md-9' : 'col-md-12'">
		<app-component-loader [f]="14"
			[w]="100"
			[h]="100"
			[style]="'margin-top: 44px'"
			[loading]="loading"></app-component-loader>
		<table
			class="table table-borderless w-100 "
			*ngIf="phases">
			<thead
				style="border-bottom: 4px solid #e9ecef">
				<tr>
					<th colspan="2">
						<div class="d-flex tw-flex-col">
							<span class="d-flex tw-items-center"
								class="link"
								role="button"
								placement="bottom">
								<span class="h3"> {{
									filterModel.node?.name
									|| 'Loading...' }}
								</span>
								<span class="tw-text-xs tw-text-gray-500 tw-ml-2">
									{{currentHistory?.createdDate | date:'MMM d, y' || 'Current'}}
								</span>
								<i class="fa tw-text-sm fa-refresh tw-ml-2 tw-cursor-pointer tw-text-blue-600 hover:tw-text-blue-800" aria-hidden="true" (click)="clearCacheAndReload()"></i>
							</span>
							<span class="tw-text-xs tw-text-gray-500 tw-mt-1 print:tw-hidden">Generated on: {{getLastPulledFormatted()}}</span>
						</div>
					</th>
					<th>Raw</th>
					<th>Percentage</th>
				</tr>
				<tr>
					<th class="fa-complete" width="10"></th>
					<th>
							Complete
					</th>
					<th class="bg-gold">{{countCompleteNotExcluded() || 0}}</th>
					<th class="bg-gold">{{this.completedPercent ||0}} %</th>
				</tr>
			</thead>
			<tbody
				*ngFor="let phase of phases; let p = index"
				style="border-bottom: 4px solid #e9ecef">
				<tr>
					<td rowspan="6"
						class="fa-{{ phase.assessmentBookId }}"
						[width]="10"></td>
					<td rowspan="6"
						style="background-color: white">
						{{ phase.title }}</td>
				</tr>
				<tr
					*ngFor="let i of [0, 1, 2, 3, 4]">
					<td
						[ngClass]="getColorClass(i) + ' pt-3' + 'h1'">
						{{
						data?.[phase.assessmentBookId]?.['current']?.['divisions'].data[i] ??
						0 }}</td>
					<td
						[ngClass]="getColorClass(i) + ' pt-3' + 'h1'">
						{{data?.[phase.assessmentBookId]?.['current']?.['divisions'].percentage[i] || 0}}
						%</td>
				</tr>
			</tbody>
		</table>


		<!-- Grade Breakdown by Phase -->

	</div>
	<div class="col-sm m-0 p-2 col-md-3"
		*ngIf="data">
		<div class="card"
			*ngIf="data">
			<app-component-loader
				[spinStyle]="'display:none'"
				[f]="14"
				[w]="100"
				[h]="100"
				[style]="'margin-top: 44px'"
				[loading]="loading"></app-component-loader>
			<div class="card p-3">
				<table
					class="table table-sm text-reset ">
					<tbody>
						<tr>
							<td
								class="text-muted border-0">
								Students Assessed</td>
							<td class="border-0 tw-text-right">
								{{getAssessedCount() || 0}}
						</td>
						</tr>
						<tr>
							<td class="text-muted">Not
								Assessed</td>
							<td class="text-right">
								{{countNotAssessedStudents() || 0}}
							</td>
						</tr>
						<tr>
							<td class="text-muted">
								Total	Students
							</td>
							<td class="text-right">
								{{countStudents() || 0}}
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div *ngIf="readingAchievementHistory.length > 0" class="tw-flex tw-items-center tw-justify-center tw-py-1 tw- tw-relative ">
				<button
					*ngIf="readingAchievementHistory.length > 0"
					(mousedown)="startHistoryChange('next')"
					(mouseup)="stopHistoryChange()"
					(mouseleave)="stopHistoryChange()"
					ngbTooltip="Previous"
					[disabled]="currentHistoryIndex === readingAchievementHistory.length - 1"
					class="tw-bg-white tw-text-gray-600 tw-border tw-border-gray-300 tw-w-7 tw-h-7 tw-rounded tw-flex tw-items-center tw-justify-center tw-shadow-sm hover:tw-bg-gray-50 focus:tw-outline-none print:tw-hidden disabled:tw-opacity-50 tw-flex-shrink-0">
					<i class="fa fa-chevron-left tw-text-xs"></i>
				</button>
				<div class="tw-flex-1 tw-mx-0.5">
					<div class="text-uppercase tw-px-3  tw-border tw-border-gray-300 tw-rounded-sm  tw-bg-white tw-text-gray-700 tw-relative tw-w-full">
						<div class="tw-flex tw-items-center tw-justify-between tw-cursor-pointer tw-transition-all tw-duration-200" (click)="isDropdownOpen = !isDropdownOpen" (mouseover)="isDropdownOpen = true" (mouseleave)="isDropdownOpen = false">
							<span class="tw-flex-1 tw-text-center">{{ (currentHistory?.createdDate | date:'MMM d, y') || 'CURRENT' }}</span>
							<i *ngIf="readingAchievementHistory.length > 0" class="fa tw-transition-transform tw-duration-300 tw-ease-in-out tw-ml-2" [class.fa-caret-up]="!isDropdownOpen" [class.fa-caret-down]="isDropdownOpen" [class.tw-rotate-180]="isDropdownOpen"></i>
						</div>
						<div *ngIf="readingAchievementHistory.length > 0" (mouseover)="isDropdownOpen = true" (mouseleave)="isDropdownOpen = false" class="tw-absolute tw-left-0 tw-bottom-full tw-w-full tw-bg-white tw-shadow-lg tw-rounded-lg tw-overflow-hidden tw-z-50 tw-transform tw-origin-bottom tw-transition-all tw-duration-300 tw-ease-in-out" [class.tw-translate-y-0]="isDropdownOpen" [class.tw-translate-y-2]="!isDropdownOpen" [class.tw-opacity-100]="isDropdownOpen" [class.tw-opacity-0]="!isDropdownOpen">
							<div class="tw-py-1 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg">
								<div class="tw-max-h-[300px] tw-overflow-y-auto" *ngIf="isDropdownOpen">
									<div *ngFor="let history of readingAchievementHistory; let i = index"
										(click)="changeHistory(i)"
										class="tw-px-4 tw-py-2 tw-text-sm tw-text-gray-700 hover:tw-bg-gray-100 tw-cursor-pointer tw-transition-colors tw-duration-200" [ngClass]="{'tw-bg-gray-100': currentHistoryIndex === i}">
										{{ history.createdDate | date:'MMM d, y' }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<button
					*ngIf="readingAchievementHistory.length > 0"
					(mousedown)="startHistoryChange('previous')"
					(mouseup)="stopHistoryChange()"
					(mouseleave)="stopHistoryChange()"
					ngbTooltip="Next"
					[disabled]="currentHistoryIndex === 0"
					class="tw-bg-white tw-text-gray-600 tw-border tw-border-gray-300 tw-w-7 tw-h-7 tw-rounded tw-flex tw-items-center tw-justify-center tw-shadow-sm hover:tw-bg-gray-50 focus:tw-outline-none print:tw-hidden disabled:tw-opacity-50 tw-flex-shrink-0">
					<i class="fa fa-chevron-right tw-text-xs"></i>
				</button>
				<button

					[class.tw-opacity-100]="selectedHistory"
					[class.tw-opacity-0]="!selectedHistory"
					(click)="loadData()"
					ngbTooltip="Back to today"
					class="tw-bg-white tw-text-red-600 tw-border tw-border-gray-300 tw-w-8 tw-h-7 tw-px-1 tw-rounded tw-flex tw-items-center tw-justify-center tw-shadow-sm hover:tw-bg-red-50 focus:tw-outline-none print:tw-hidden tw-flex-shrink-0 tw-ml-0.5">
					<i class="fa fa-times tw-text-xs"></i>
				</button>
			</div>

		<div  *ngIf="!selectedHistory">
			<div class="card-body p-2 border">
				<div class="form-check">
					<input type="checkbox"
						   class="form-check-input"
						   id="includeNotAssessed"
						   [checked]="filterModel.includeNoneAssessed"
						   (change)="toggleNoneAssessed()">
					<label class="form-check-label" for="includeNotAssessed">
						Include Not Assessed
					</label>
				</div>
			</div>
			<div
				*ngFor="let item of filterModel.characteristics | keyvalue">
				<app-raw-filter [key]="item.key"
					[filterModel]="item.value"
					*ngIf="item.value.length > 1"
					(filterChanged)="handleFilterChange($event)"></app-raw-filter>
			</div>
		</div>
		</div>
	</div>
</div>
